import React, { Component } from "react";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../config.json";
import ReCAPTCHA from "react-google-recaptcha";
import "./Abha.css";

export default class MobileAuthentication extends Component {
  constructor(props) {
    super(props);
    this.recaptchaRef = React.createRef();
    this.state = {
      textexpanded: false,
      mobile: "",
      // for the 3 parts

      captchaToken: null,
    };
  }
  handleCaptchaChange = (value) => {
    this.setState({
      captchaToken: value,
    });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };
  toggleReadMore = () => {
    this.setState((prevState) => ({ textexpanded: !prevState.textexpanded }));
  };
  handleaadhaarchange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ aadharNumber: fieldValue });
  };

  HandleSubmit = (e) => {
    e.preventDefault();
    const { captchaToken, mobile } = this.state;
    if (mobile.trim() === "") {
      this.showToast("Mobile number is required.", "error");
      return;
    }
    const mobileRegex = /^[6-9]\d{9}$/;
    if (!mobileRegex.test(mobile.trim())) {
      this.showToast("Enter a valid 10-digit mobile number.", "error");
      return;
    }

    if (!captchaToken) {
      alert("Please verify that you are not a robot!");
      return;
    }
    this.setState({ isSubmitting: true });
    var formData = new FormData();
    formData.append("mobile", mobile);
    formData.append("captchaToken", captchaToken);

    fetch(configData.api_url + "C_Abhadetails/mobileSearchVerify", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);
        if (data.status === "success") {
          sessionStorage.setItem("requestId", data.requestId);
          sessionStorage.setItem("mobile", this.state.mobile);

          sessionStorage.setItem("message", data.details.message);
          window.location.href = "/Mobilenumberotp";

          // this.mobileSearchVerify();
        }
        // this.setState({

        //   isSubmitting: false,
        // });
      });
  };

  mobileSearchVerify = () => {
    const { mobile, captchaToken } = this.state;
    const formData = new FormData();
    formData.append("mobile", mobile);
    formData.append("captchaToken", captchaToken);
    // formData.append("requestId", sessionStorage.requestId);
    fetch(configData.api_url + "C_Abhadetails/mobileSearchVerify", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message);

        if (data.status === "success") {
          window.location.href = "/Mobilenumberotp";
        }
      });
  };
  onKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
      toast.error("Spaces are not allowed.");
    }
  };
  handlemobileChange = (e) => {
    const input = e.target.value;

    // Allow only digits (remove any non-digit character)
    const digitsOnly = input.replace(/\D/g, "");

    // Optionally restrict to 10 digits ma
    if (digitsOnly.length <= 10) {
      this.setState({ mobile: digitsOnly });
    }
  };

  handleAuthChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ authenticationtype: fieldValue });
  };
  HandleBackSubmit = () => {
    window.location = "./abharegister";
  };
  resetCaptcha = () => {
    this.setState({ captchaToken: "" });
    if (this.recaptchaRef && this.recaptchaRef.current) {
      this.recaptchaRef.current.reset();
    }
  };
  render() {
    const { mobile } = this.state;
    return (
      <div>
        <div className="row mb-2" id="flowStyle">
          <div className="col-md-3 flowTab Inactive">
            <div className="widget_BG widget_BG_grid bi bi-collection nav-icon">
              <p className="nav-label mt-2">Consent Collection</p>
            </div>
          </div>

          <div className="col-md-3 flowTab active-page">
            <div className="widget_BG widget_BG_grid bi bi-file-richtext nav-icon">
              <p className="nav-label mt-2">ABHA Authentication</p>
            </div>
          </div>
          <div className="col-md-3 flowTab Inactive">
            <div className="widget_BG widget_BG_grid bi bi-info-square nav-icon">
              <p className="nav-label mt-2">Communication Details</p>
            </div>
          </div>
          <div className="col-md-3 flowTab Inactive">
            <div className="widget_BG widget_BG_grid bi bi-file-person nav-icon">
              <p className="nav-label mt-2">ABHA Address Creation</p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center text-center consentCollectionAadhaar">
          <div className="col-md-6 mt-3">
            <div className="">
              <Form>
                <Form.Group>
                  <Form.Label>
                    <b>Enter 10 Digit Mobile Number</b>
                  </Form.Label>
                  <div
                    className="rounded-0 m-1"
                    style={{
                      gap: "10px",
                    }}
                  >
                    <div className="m-1" style={{ display: "flex" }}>
                      <span
                        style={{
                          padding: "4px 12px",
                          background: "#eee",
                          border: "1px solid #ccc",
                          borderRight: "none",
                          borderRadius: "0px",
                        }}
                      >
                        +91
                      </span>
                      <Form.Control
                        id="mobile"
                        className="form-control rounded-0 "
                        style={{ width: "250px" }}
                        type="text"
                        maxLength={10}
                        value={mobile}
                        onKeyDown={this.onKeyDown}
                        onChange={this.handlemobileChange}
                        placeholder="Enter mobile number"
                      />
                    </div>
                  </div>
                  <br />

                  <div className="d-flex">
                    <ReCAPTCHA
                      className="mt-4"
                      ref={this.recaptchaRef}
                      sitekey={configData.captchaKey}
                      onChange={this.handleCaptchaChange}
                    />
                    <Button
                      variant="secondary"
                      className="bi bi-arrow-clockwise re-chaptue"
                      onClick={() => this.recaptchaRef.current.reset()}
                    />
                  </div>
                </Form.Group>
              </Form>
            </div>
          </div>
        </div>
        <div className="row  widget_BG widget_BG_grid m-0 mt-2">
          <div className="col text-start">
            <Button
              className="rounded-0 m-1 "
              variant="warning"
              onClick={this.HandleBackSubmit}
            >
              Back
            </Button>
          </div>
          <div className="col text-end">
            <Button
              className="rounded-0 m-1"
              disabled={this.state.isSubmitting}
              onClick={this.HandleSubmit}
            >
              {this.state.isSubmitting
                ? "Submitting..."
                : "Verifiy Mobile Number"}
            </Button>
          </div>
        </div>

        <div className="row" style={{ height: "70px" }}></div>
      </div>
    );
  }
}
